module.exports = __webpack_public_path__ + "static/media/39-1.678ce732.mp3";